import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './NotFound.css';
import { Typography } from '@mui/material';

const errorImage = require('../../assets/img/chilin-preocupado.png');

const AuthError = () => {
  const [message, setMessage] = useState('Ha ocurrido un error al iniciar sesión.');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('authError');

    if (error === 'YaRegistrado') {
      setMessage('Este correo ya fue registrado con otro método de autenticación.');
    } else if (error) {
      setMessage(decodeURIComponent(error));
    }
  }, []);

  return (
    <div>
      <Header />
      <Typography className='titleNotFount'>Oops!</Typography>
      <Typography className='subtitleYaRegistrado'>{message}</Typography>
      <img
        src={errorImage}
        alt="auth error"
        className="notfound"
      />
      <Footer />
    </div>
  );
};

export default AuthError;
